<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">KYKM</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" v-model="value.Name" class="form-control" placeholder="KYKM"/>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Tip</label>
            <v-validator :errors="errors" parameter="TIP" :watch="value.TIP">
                <select class="form-control" v-model="value.TIP">
                    <option :value="null" disabled v-if="value.TIP == null">Tip</option>
                    <option v-for="tip in tips" :value="tip.value">{{ tip.name }}</option>
                </select>
            </v-validator>
        </div> 
        <div class="col-md-6 mb-1">
            <label class="form-label">Sıra No</label>
            <v-validator :errors="errors" parameter="SIRA_NO" :watch="value.SIRA_NO">
                <input class="form-control" type="number" v-model="value.SIRA_NO" placeholder="Sıra No">
            </v-validator>
        </div>
        <div class="col-12 mb-1" v-if="value.TIP == 1">
            <label class="form-label">Kat Sayı</label>
            <v-validator :errors="errors" parameter="Multiplier" :watch="value.Multiplier">
                <b-form-spinbutton min="0" step="0.25" v-model="value.Multiplier"></b-form-spinbutton>
            </v-validator>
        </div> 
        <div class="col-12 mb-1">
            <label class="form-label">Ücret Nevi</label>
            <v-select-list v-model="kind" label="Combine" placeholder="Ücret Nevi" :options="kinds"/>
        </div>
        <div class="col-12 mb-1" v-if="value.TIP == 1">
            <label class="form-label">SGK Gün</label>
            <v-select-list v-model="sgkDayKind" label="Combine" placeholder="SGK Gün Türü" :options="sgkDayKinds"/>
        </div>
    </div>
</template>

<script>
import { BFormSpinbutton } from 'bootstrap-vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';

export default {
    components:{
        BFormSpinbutton
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return {
            kinds:[],
            sgkDayKinds:[],
            tips:[
                {name:'Kazanç',value:'1'},
                {name:'Kesinti',value:'3'},
            ]
        }
    },
    mounted(){
        this.getKinds()
        this.getSGKDayKinds()
    },
    methods:{
        getKinds(){
            HumanResourcesParameterApi.KYKM.KindList().then(res => {
                this.kinds = res.data.Data?.map(k => ({
                    ...k,
                    Combine:[k.Code,k.Name].join(' - ')
                }))
            })
        },
        getSGKDayKinds(){
            HumanResourcesParameterApi.KYKM.SGKDayKindList().then(res => {
                this.sgkDayKinds = res.data.Data?.map(k => ({
                    ...k,
                    Combine:[k.Code,k.Name].join(' - ')
                }))
            })
        }
    },
    computed:{
        kind:{
            get:function(){
                return this.kinds.find(b=>b.Id==this.value.KYKMKindId)
            },
            set:function(value){
                this.value.KYKMKindId = value?.Id || null
            }
        },
        sgkDayKind:{
            get:function(){
                return this.sgkDayKinds.find(b=>b.Id==this.value.KYKMSgkDayKindId)
            },
            set:function(value){
                this.value.KYKMSgkDayKindId = value?.Id || null
            }
        }
    }
}
</script>